import { Controller } from "@hotwired/stimulus"
import { TaskScheduler } from "../utils/scheduler"

export default class extends Controller {
  static targets = ["text"]
  static values = {
    start: String,
    end: String,
    notOpenText: { type: String, default: "距离开市还剩" },
    closedText: { type: String, default: "已闭市" },
    runningText: { type: String, default: "距离闭市还剩" },
  }

  connect() {
    this.scheduler = new TaskScheduler({
      start: this.startValue,
      end: this.endValue,
      interval: 1000,
      onTick: () => this.update(),
      onPendingTick: () => this.update(),
      onStateChange: (s) =>
        s === "expired" && (this.textTarget.textContent = this.closedTextValue),
    })
    this.scheduler.schedule()
  }

  disconnect() {
    this.scheduler?.stop()
  }

  update() {
    const now = new Date()
    const isPending = now < this.scheduler.startTime
    const target = isPending ? this.scheduler.startTime : this.scheduler.endTime
    const label = isPending ? this.notOpenTextValue : this.runningTextValue
    const ms = Math.max(0, target - now)

    if (ms === 0 && !isPending) return

    const time = new Date(ms).toISOString().slice(11, 19)
    this.textTarget.innerHTML = `${label} <strong>${time}</strong>`
  }
}
